<link href="https://fonts.cdnfonts.com/css/gotham" rel="stylesheet">

<div class="fixed-top custombg" style=" z-index: 100;">
    <div class="d-flex flex-column">
        <app-header #header></app-header>
        <app-breadcrumb></app-breadcrumb>
    </div>
</div>

<div class="mainclass wrapper row">
    <app-project-detail [auditId]="auditId" [selectedProjectStatusId]="selectedProjectStatusId" 
        [selectedProjectStatusDescription]="selectedProjectStatusDescription"
        class="mainclass"></app-project-detail>
    <div class="stageTable">
        <ng-container *ngFor="let vm of CategoryViewModels">
            <div class="stageTable" [attr.data-stage]="vm.categoryModel.categoryName">
                <table class="stageBars">
                    <tr class="stageOne" (click)="navigateToQuestionTable(vm)">
                        <td style="width: 25%;">
                            <div>
                                <span class="stage-name">{{vm.categoryModel.categoryName}}</span>
                            </div>
                        </td>
                        <td style="width: 20%;"nowrap="nowrap">
                            <div *ngIf = "(selectedProjectStatusId >= 5)">
                                <span class = "dateText">Sub Auditor: </span>
                                <span class = "subAuditor-text">{{vm.categoryModel.subAuditiorName}}</span>
                            </div>
                        </td>
                        <td style="width: 15%;">
                            <div class="date">
                                <span class="dateText">Start Date: </span>
                                <span class="dateprint">{{vm.startDate | date: 'MM-dd-yyyy' : "N/A"}}</span>
                            </div>
                        </td>
                        <td style="width: 15%;">
                            <div class="review">
                                <span class="reviewtext">Rating : </span>
                                <div class="star-icons"
                                    *ngFor="let star of createRange(vm.categoryModel.auditCategoryReview?.length > 0 ? vm.categoryModel.auditCategoryReview[0].rating : 1)">
                                    <i class="fa fa-star"
                                        *ngIf="(vm.categoryModel.auditCategoryReview?.length > 0 && vm.categoryModel.auditCategoryReview[0].rating > 0)"></i>
                                    <span class="ratingtext">{{(vm.categoryModel.auditCategoryReview?.length > 0 &&
                                        vm.categoryModel.auditCategoryReview[0].rating > 0)? "" : 'N/A'}}</span>
                                </div>
                            </div>
                        </td>
                        <td class="assign-btn-wrapper" style="width: 25%">
                            <!-- (change)="saveSelectedAssignee($event, vm.categoryModel.description)" in select tag of html-->
                            <select class="form-control" [disabled]="selectedProjectStatusId != 5 || !isManagerLoggedIn"
                                [(ngModel)]="vm.selectedAssigneeId" class="form-select"(click)="$event.stopPropagation()">
                                <option disabled selected hidden value="0">Select Reviewer</option>
                                <option *ngFor="let assignee of assigneesDetail" [value]="assignee.userId">
                                    {{assignee.userName}}
                                </option>
                            </select>
                        </td>
                        <td style="margin-left: 20px;">
                            <span>
                                <i [ngClass]="(vm.isAccordionOpen) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" 
                                    aria-hidden="true"></i>
                            </span>
                            <!-- <span *ngIf="!vm.isAccordionOpen">
                                <i class="fa fa-chevron-down" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="vm.isAccordionOpen">
                                <i class="fa fa-chevron-up" aria-hidden="true"></i>
                            </span> -->
                        </td>
                    </tr>
                </table>
                <div *ngIf="vm.isAccordionOpen" class="accordiantext">
                    <div class="d-flex">
                        <div class="date">
                            <span class="dateText">isCategorySubmitted: </span>
                            <span class="dateprint">{{vm.isSubmitted ?? "Undefined"}}</span>
                        </div>
                        <div class="date">
                            <span class="dateText">discrepancyRaised: </span>
                            <span class="dateprint">{{vm.discrepancyRaised ?? "Undefined"}}</span>
                        </div>
                    </div>
                    <div class="table-container">
                        <table class="border 1px">
                            <thead class="border 1px">
                                <tr class="border 1px">
                                    <th class="th-accordian" style="width:100px;">Sub-Category</th>
                                    <th class="th-accordian">Audit Question</th>
                                    <th class="th-accordian" style="width:100px;">Weightage</th>
                                    <th class="th-accordian" colspan="3" style="width:150px;">Comments</th>
                                    <th class="th-accordian" style="width:100px;">Sub-Auditor</th>
                                </tr>
                                <tr>
                                    <th class="th-accordian"></th>
                                    <th class="th-accordian"></th>
                                    <th class="th-accordian"></th>
                                    <th class="th-accordian" style="width:100px;">Response<sup class="requiredStar">*</sup></th>
                                    <th class="th-accordian" style="width:50px;">Supporting Material</th>
                                    <th class="th-accordian" style="width:150px;">Observations, Exceptions and Reason
                                        for Non Compliance<sup class="requiredStar">*</sup>
                                    </th>
                                    <th class="th-accordian"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of accordionData[vm.categoryModel.categoryName]">
                                    <td class="td-accordian">{{
                                        data.category }}</td>
                                    <td class="td-accordian" style="text-align: start;">{{ data.questions }}</td>
                                    <td class="td-accordian">{{ data.weightage }}</td>
                                    <td class="td-accordian">
                                        <select class="dropdown" placeholder="select"
                                            title="{{ getDropdownTooltip(data.selectedResponseOption) }}"
                                            [(ngModel)]="data.selectedResponseOption" 
                                            [disabled]="(!(isManagerLoggedIn && (selectedProjectStatusId == 7))) && (vm.isSubmitted || (!((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6))))">
                                            <option disabled selected hidden value=0>Select Response</option>
                                            <option *ngFor="let option of responseDropDownOptions" [value]="option.id">
                                                {{option.description}}</option>
                                        </select>
                                    </td>
                                    <!-- (!vm.discrepancyRaised && !vm.isSubmitted && (((isManagerLoggedIn && (selectedProjectStatusId == 7)) || ((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6)))))
                                            (vm.discrepancyRaised || vm.isSubmitted || (!((isManagerLoggedIn && (selectedProjectStatusId == 7)) || ((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6))))) -->
                                    <td class="td-accordian">
                                        <select [(ngModel)]="data.supportingMaterial" 
                                            [disabled]="(!(isManagerLoggedIn && (selectedProjectStatusId == 7))) && (vm.isSubmitted || (!((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6))))">
                                            <!-- <option [ngValue]=0 disabled selected hidden>Select Supporting Material
                                            </option> -->
                                            <option [ngValue]=0>False</option>
                                            <option [ngValue]=1>True</option>
                                        </select>
                                    </td>
                                    <td class="td-accordian">
                                        <textarea [(ngModel)]="data.comment"
                                            placeholder="Enter Comments"
                                            [disabled]="(!(isManagerLoggedIn && (selectedProjectStatusId == 7))) && (vm.isSubmitted || (!((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6))))"
                                            rows="3" ></textarea>
                                        <!-- <input type="text" [(ngModel)]="data.comment"
                                            placeholder="Enter Comments" 
                                            [disabled]="(!(isManagerLoggedIn && (selectedProjectStatusId == 7))) && (vm.isSubmitted || (!((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6))))"> -->
                                    </td>
                                    <td class="td-accordian">
                                        <textarea [(ngModel)]="data.auditorComment"
                                        placeholder="Enter Comments" [disabled]="disableCommentsAndRatings" rows="3"></textarea>
                                        <!-- <input type="text" [(ngModel)]="data.auditorComment"
                                            placeholder="Enter Comments" [disabled]="disableCommentsAndRatings"> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="buttons" *ngIf="(isManagerLoggedIn && (selectedProjectStatusId == 7)) || (!vm.isSubmitted && ((loggedInEmployeeId == vm.selectedAssigneeId) && (selectedProjectStatusId == 6)))">
                            <span *ngIf="1 < 0" class="align-middle submit-error-message"
                                [ngClass]="{'text-success':!isError,'text-danger': isError}">
                                {{questionSaveErrorMessage}}</span>
                            <!-- <button class="custom_btn primary_btn_base mr-2" (click)="sendNotification()" [disabled]="!canEditCategory(vm.categoryModel.id)">Clarification
                                Needed</button> -->
                            <button class="custom_btn inverted_btn_base mr-2"
                                (click)="resetQuestionTable(vm.categoryModel.categoryName)" 
                                >Clear</button>
                            <button (click)="saveQuestionTableResponseData(vm.categoryModel.categoryName)"
                                class="custom_btn primary_btn_base" 
                                >Save</button>
                            <!-- save button should be there only if there are changes xan take common variable named ifChanges and use it for every stage-->
                            <button (click)="submitQuestionTableResponseData(vm.categoryModel.categoryName)"
                                class="custom_btn primary_btn_base" *ngIf="!(isManagerLoggedIn && (selectedProjectStatusId == 7))"
                                >Submit</button>
                        </div>
                    </div>
                    <div class="finalReview mt-2">
                        <div class="rating" [disabled]="disableCommentsAndRatings">
                            <label>
                                <input type="checkbox" [(ngModel)]="vm.discrepancyRaised">
                                Clarification Needed 
                            </label>
                            <div class="starText">
                                <span id="stagetext">Category Rating &nbsp; : &nbsp;</span>
                                <div class="star-icons" *ngIf="!((loggedInEmployeeId === vm.categoryModel.subAuditiorUserId) && (selectedProjectStatusId == 8))">
                                    <span *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                                        <i class="fa fa-star" 
                                           [ngClass]="{
                                              'text-warning': i < stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating, 
                                              'text-secondary': i >= stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating
                                            }">
                                        </i>
                                    </span>
                                </div>
                                <!-- {{stageReviewDetailsMap[vm.categoryModel.description] | json}} -->
                                <div class="star-icons" *ngIf="((loggedInEmployeeId === vm.categoryModel.subAuditiorUserId) && (selectedProjectStatusId == 8))">
                                    <div class="containet" >
                                        <input type="radio" name="rating_{{vm.categoryModel.categoryName}}" value="5"
                                            (change)="ratingChangeHandlerforAccordion($event, vm.categoryModel.categoryName)"
                                            [checked]="stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating === 5" />
                                        <input type="radio" name="rating_{{vm.categoryModel.categoryName}}" value="4"
                                            (change)="ratingChangeHandlerforAccordion($event, vm.categoryModel.categoryName)"
                                            [checked]="stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating === 4" />
                                        <input type="radio" name="rating_{{vm.categoryModel.categoryName}}" value="3"
                                            (change)="ratingChangeHandlerforAccordion($event, vm.categoryModel.categoryName)"
                                            [checked]="stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating === 3" />
                                        <input type="radio" name="rating_{{vm.categoryModel.categoryName}}" value="2"
                                            (change)="ratingChangeHandlerforAccordion($event, vm.categoryModel.categoryName)"
                                            [checked]="stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating === 2" />
                                        <input type="radio" name="rating_{{vm.categoryModel.categoryName}}" value="1"
                                            (change)="ratingChangeHandlerforAccordion($event, vm.categoryModel.categoryName)"
                                            [checked]="stageReviewDetailsMap[vm.categoryModel.categoryName]?.rating === 1" />
                                    </div>
                                </div>
                            </div>
                            <div class="buttonsmain">
                                <div class="auditorComments">
                                    <span id="stagetext">Sub-Auditor Comments <sup class="requiredStar">*</sup></span>
                                    <input type="text" [ngModel]="getCommentForAccordion(vm.categoryModel.categoryName)"
                                        (ngModelChange)="setCommentForAccordion(vm.categoryModel.categoryName, $event)"
                                        name="textReviewComment" placeholder="Enter comment text here"
                                        class="custom-input" [disabled]="disableCommentsAndRatings">
                                </div>
                                <div class="buttons m-b-4">
                                    <span *ngIf="1 < 0" class="align-middle submit-error-message"
                                        [ngClass]="{'text-success':!isError,'text-danger': isError}">
                                        {{reviewSaveErrorMessage}}</span>
                                    <div *ngIf="(loggedInEmployeeId == vm.categoryModel.subAuditiorUserId) && (selectedProjectStatusId == 8)">
                                        <!-- <button *ngIf="selectedProjectStatusId == 8" class="custom_btn primary_btn_base mr-2" 
                                            (click)="clarificationNeededForCategoryButtonClicked(vm)">Clarification Needed</button> -->
                                        <!-- <button class="custom_btn primary_btn_base"
                                            (click)="submitCategoryReview(vm.categoryModel.categoryName)" 
                                            title="Submit Category Review"
                                            *ngIf="ratingId < 1 && !hideSubmitButton">Submit
                                        </button> -->
                                        <button (click)="saveSubAuditorComments(vm.categoryModel.categoryName)"
                                            class="custom_btn primary_btn_base">Save</button>
                                        <button (click)="combinedSubmitFunctionality(vm)"
                                            class="custom_btn primary_btn_base"> {{ vm.discrepancyRaised ? 'Clarification needed' : 'Submit' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="projectSummary" *ngIf="selectedProjectStatusId > 8">
        <div class="title auditSummary" (click)="toggleVisibility(auditSummaryCard)">
            <span id="textTitle">Audit Summary</span>
            <span *ngIf="isAuditSummarayVisible">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </span>
            <span *ngIf="!isAuditSummarayVisible">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
            </span>
        </div>
        <div class="summaryTable" *ngIf="!isAuditSummarayVisible">
            <table>
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>Weightage</th>
                        <th colspan="2">Overall Rating</th>
                        <th>Comments (If any)</th>
                        <th></th>
                    </tr>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>UI Layer</th>
                        <th>Middle and DB Layer</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody *ngIf="auditSummaryFormModelArray">
                    <tr *ngFor="let formModel of auditSummaryFormModelArray; let i=index">
                        <td [attr.data-form-index]="i">
                            <select class="form-control" [(ngModel)]="formModel.categoryId" 
                            [disabled]="disablingCommentsAndRatingStage9Auditor" 
                            [class.invalid]="hasErrors && (!formModel.categoryId || formModel.categoryId === -1)">
                                <option disabled selected hidden value=-1>Select Category</option>
                                <option *ngFor="let item of categoryModels" [value]="item.categoryId">{{item.categoryName}}
                                </option>
                            </select>
                        </td>
                        <td><input type="text" class="form-control" placeholder="Enter Weightage"
                                [(ngModel)]="formModel.weightage" [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [class.invalid]="hasErrors && (!formModel.weightage)"></td>
                        <td>
                            <select class="form-control" [(ngModel)]="formModel.uiLayerRating" 
                            [disabled]="disablingCommentsAndRatingStage9Auditor"
                            [class.invalid]="hasErrors && (!formModel.uiLayerRating || formModel.uiLayerRating === -1)">
                                <option disabled selected hidden value=-1>Select UI Layer</option>
                                <option *ngFor="let item of responeOtions" [value]="item.id">{{item.description}}
                                </option>
                            </select>
                        </td>
                        <td>
                            <select class="form-control" [(ngModel)]="formModel.middleAndDbLayerRating"
                            [disabled]="disablingCommentsAndRatingStage9Auditor" 
                            [class.invalid]="hasErrors && (!formModel.middleAndDbLayerRating || formModel.middleAndDbLayerRating === -1)">
                                <option disabled selected hidden value=-1>Select Middle and DB Layer</option>
                                <option *ngFor="let item of responeOtions" [value]="item.id">{{item.description}}
                                </option>
                            </select>
                        </td>
                        <td>
                            <textarea rows="1" id="enterComments" [(ngModel)]="formModel.comments"
                            [disabled]="disablingCommentsAndRatingStage9Auditor" placeholder="Enter comments here"></textarea>
                        </td>
                        <td>
                            <button [attr.data-rowindex]="i" (click)="removeRow($event,auditSummaryFormModelArray)"
                            [disabled]="disablingCommentsAndRatingStage9Auditor" 
                            type="button" class="close" aria-label="Close">
                                <span [attr.data-rowindex]="i" aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="addRowbtn" *ngIf="!disablingCommentsAndRatingStage9Auditor">
                <span class="align-middle submit-error-message"
                    [ngClass]="{'text-success':!isError,'text-danger': isError}">{{auditSummarySaveMessage}}</span>
                <button class="custom_btn inverted_btn_base mr-2" type="button"
                    (click)="addDynamicFormControls(CardTypes.AuditSummary)">Add Row</button>
                <button class="custom_btn primary_btn_base" type="submit" (click)="saveAuditSummary()">Save</button>
            </div>
        </div>

    </div>


    <div class="projectSummary" *ngIf="selectedProjectStatusId > 8">
        <div class="title auditSummary" (click)="toggleVisibility(riskRegisterCard)">
            <span id="textTitle">Risk Register</span>
            <span *ngIf="isRiskRegisterVisible">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </span>
            <span *ngIf="!isRiskRegisterVisible">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
            </span>
        </div>
        <div class="summaryTable overflow-scroll-y" *ngIf="!isRiskRegisterVisible">
            <table>
                <thead>
                    <tr>
                        <th>Layer</th>
                        <th>Component</th>
                        <th>Risk</th>
                        <th>Mitigation Plan</th>
                        <th>Registered by (Project / Practice)</th>
                        <th>Status</th>
                        <th>Closer Date</th>
                        <th>Comments</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let formModel of riskRegisterFormModelArray; let i = index">
                        <td>
                            <select class="form-control selectdropdownbox" [(ngModel)]="formModel.categoryId" 
                            [disabled]="disablingCommentsAndRatingStage9Auditor"
                            [class.invalid]="hasErrors && (!formModel.categoryId || formModel.categoryId === -1)">
                                <option disabled selected hidden value=-1>Select Layer</option>
                                <option *ngFor="let item of categoryModels" [value]="item.categoryId">{{item.categoryName}}
                                </option>
                            </select>
                        </td>
                        <td>
                            <select class="form-control selectdropdownbox" [(ngModel)]="formModel.componentId"
                            [disabled]="disablingCommentsAndRatingStage9Auditor" 
                            [class.invalid]="hasErrors && (!formModel.componentId || formModel.componentId === -1)">
                                <option disabled selected hidden value=-1>Select Component</option>
                                <option *ngFor="let item of componenOptions" [value]="item.id">{{item.description}}
                                </option>
                            </select>
                        </td>
                        <td><textarea class="form-control" placeholder="Enter Risk" rows="1"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [(ngModel)]="formModel.risk" [class.invalid]="hasErrors && !formModel.risk"></textarea></td>
                        <td><textarea class="form-control" placeholder="Enter Mitigation Plan" rows="1"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [(ngModel)]="formModel.mitigationPlan" [class.invalid]="hasErrors && !formModel.mitigationPlan"></textarea></td>
                        <td><input class="form-control" placeholder="Enter Registered By" type="text"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [(ngModel)]="formModel.registeredBy" [class.invalid]="hasErrors && !formModel.registeredBy"></td>
                        <td><input class="form-control" placeholder="Enter Status" type="text"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [(ngModel)]="formModel.status" [class.invalid]="hasErrors && !formModel.status"></td>
                        <td><input type="date" [(ngModel)]="formModel.closerDate" placeholder="DD-MM-YYYY" 
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [class.invalid]="hasErrors && !formModel.closerDate"></td>
                        <td>
                            <textarea class="form-control" placeholder="Enter comments here" rows="1"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                [(ngModel)]="formModel.comments" [class.invalid]="hasErrors && !formModel.comments"></textarea>
                        </td>
                        <td>
                            <button [attr.data-rowindex]="i" (click)="removeRow($event,riskRegisterFormModelArray)"
                                [disabled]="disablingCommentsAndRatingStage9Auditor" 
                                type="button" class="close" aria-label="Close">
                                <span [attr.data-rowindex]="i" aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="addRowbtn" *ngIf="!disablingCommentsAndRatingStage9Auditor">
                <span class="align-middle submit-error-message"
                    [ngClass]="{'text-success':!isError,'text-danger': isError}">{{riskRegusterSaveMessage}}</span>
                <button class="custom_btn inverted_btn_base mr-2"
                    (click)="addDynamicFormControls(CardTypes.RiskRegister)">Add Row</button>
                <button class="custom_btn primary_btn_base" (click)="saveRiskRegister()">Save</button>
            </div>
        </div>
    </div>

    <div class="finalReview" *ngIf="selectedProjectStatusId > 8">
        <div class="rating">
            <div class="starText">
                <span id="stagetext">Rating &nbsp; : &nbsp;</span>
                <div class="star-icons">
                    <span *ngFor="let start of createRange(finalReviewRating?.rating)">
                        <i class="fa fa-star" *ngIf="finalReviewRating"></i>
                    </span>
                </div>
                <div class="star-icons" *ngIf="finalReviewRating?.rating < 1">
                    <div class="containet" >
                        <input type="radio" name="clr" [style]="disablingCommentsAndRatingStage9Auditor ? '#ff9933' : 'initial'"  value="5"
                        (change)="ratingChangeHandler($event)"  [disabled]="disablingCommentsAndRatingStage9Auditor" />
                    <input type="radio" name="clr" [style]="disableCommentsAndRatings ? '#ff9933' : 'initial'"  value="4"
                        (change)="ratingChangeHandler($event)"  [disabled]="disablingCommentsAndRatingStage9Auditor" />
                    <input type="radio" name="clr" [style]="disableCommentsAndRatings ? '#ff9933' : 'initial'"  value="3"
                        (change)="ratingChangeHandler($event)"  [disabled]="disablingCommentsAndRatingStage9Auditor"/>
                    <input type="radio" name="clr" [style]="disableCommentsAndRatings ? '#ff9933' : 'initial'"  value="2"
                        (change)="ratingChangeHandler($event)"  [disabled]="disablingCommentsAndRatingStage9Auditor"/>
                    <input type="radio" name="clr" [style]="disableCommentsAndRatings ? '#ff9933' : 'initial'"  value="1"
                        (change)="ratingChangeHandler($event)"  [disabled]="disablingCommentsAndRatingStage9Auditor" 
                        [class.invalid]="hasErrors && !this.finalReviewRating?.rating"/>
                </div>
                </div>
            </div>
            <div class="buttonsmain">
                <div class="auditorComments">
                    <span id="stagetext">Auditor Comments</span>
                    <input [(ngModel)]="reviewComment" type="text" id="myInput" name="textInput"
                        placeholder="Enter comments here" class="custom-input" [disabled]="disablingCommentsAndRatingStage9Auditor"
                        [class.invalid]="hasErrors && !reviewComment">
                </div>
            </div>
        </div>
    </div>
    <div class="buttons w-100">
        <span class="align-middle submit-error-message" [ngClass]="{'text-success':!isError,'text-danger': isError}"
            *ngIf="1 < 0">{{finalReviewSubmitMessage}}</span>
        <button class="custom_btn inverted_btn_base mr-2" style="float:right"
            (click)="navigateToProjectListing()">Back</button>
        <!-- <button *ngIf="isSaveButtonEnabled" class="custom_btn custom_save_btn primary_btn_base mr-2"
            (click)="saveButtonClicked()">Save</button> -->
        <button class="custom_btn primary_btn_base mr-2" *ngIf="(selectedProjectStatusId == 9 && isAuditorLoggedIn)" 
            (click)="clarificationNeededButtonClickedByAuditor()">Clarification Needed</button>
        <!-- *ngIf="finalReviewRating?.rating < 1" -->
        <button class="custom_btn true_btn"  *ngIf="(selectedProjectStatusId == 7&& isManagerLoggedIn)" (click)="ManagersubmitButtonClicked()"
        title="Submit Final Review">Submit</button>
        <button class="custom_btn true_btn" *ngIf="(selectedProjectStatusId ==  5 && isManagerLoggedIn) || (selectedProjectStatusId == 9 && isAuditorLoggedIn)" (click)="submitButtonClicked()"
            title="Submit Final Review">Submit</button>
    </div>

    <div *ngIf="isAssigneePopupVisible" class="popup">
        <div class="popup-content">
            <span id="popupText">Assign reviewer for {{clickedStage}} stage</span>

            <ul style="margin-top: 10px;">
                <li *ngFor="let assignee of assigneesDetail" (click)="selectAssigneeName(assignee,$event)">
                    {{assignee.userName}}</li>
            </ul>
            <div class="buttons">
                <button class="clarification-button" style="float:right" (click)="closePopup()">Close</button>
                <button class="submit-button" style="float:right" (click)="saveCategoryAssignee()">Save</button>
            </div>
        </div>
    </div>